export default "__VITE_ASSET__06564962__"